import React, { useEffect, useState } from 'react';
import "./IVCPage.css";
import IVCWelcomeScreen from './IVCWelcomeScreen';
import SystemDown from './SystemDown';
import WindowClosed from './WindowClosed';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';
import { getApiData } from '../../api/api';
import AxiosRequest from '../../utils/axios';
import { useHistory } from 'react-router-dom';
import IVCPolicySpliting from './IVCPolicySplitting';
import Error from '../Error/Error';

const axios = new AxiosRequest().getClient()

const IVCPage = () => {
    const router = useHistory()

    const [isSystemDown, setIsSystemDown] = useState(false);
    const [isWindowOpen, setIsWindowOpen] = useState(false);
    const [isWindowClosed, setIsWindowClosed] = useState(false);
    const [ivcDowntimeHeading, setIvcDowntimeHeading] = useState('');
    const [ivcDowntimeMessage, setIvcDowntimeMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [ivcVideoUrl, setIvcVideoUrl] = useState('');
    const [showPolicySplittingPage, setShowPolicySplittingPage] = useState(false);
    const [policySplittingMsg, setPolicySplittingMsg] = useState("");
    const [isLinkInvalid, setIsLinkInvalid] = useState(false);
    const [invalidLinkMsg, setInvalidLinkMsg] = useState("");

    useEffect(() => {
        localStorage.clear();
        hideHeaderOnIVC();
        verifyLink();
    }, [])

    const hideHeaderOnIVC = () => {
        const headBar = document.querySelector('.head-bar');
        const header = document.querySelector('.header');
        const barContainer = document.querySelector('.bar-cntnr');
        if (headBar) {
            headBar.style.display = 'none';
        }
        if (header) {
            header.style.display = 'none';
        }
        if (barContainer) {
            barContainer.style.display = 'none';
        }
    }

    const validTimeSlot = (startTime, endTime) => {
        const currentTime = new Date();
        const currentHour = currentTime.getHours() < 10 ? `0${currentTime.getHours()}` : currentTime.getHours();
        const currentMinutes = currentTime.getMinutes()< 10 ? `0${currentTime.getMinutes()}` : currentTime.getMinutes();
        const currentSeconds = currentTime.getSeconds()< 10 ? `0${currentTime.getSeconds()}` : currentTime.getSeconds();
        const timeInString = `${currentHour}:${currentMinutes}:${currentSeconds}`;
        let isWindowOpenStatus = false;
        if (timeInString >= startTime && timeInString <= endTime) {
            isWindowOpenStatus = true;
        }
        return isWindowOpenStatus;
    }

    const verifyLink = async () => {
        setLoading(true)
        const urlData = getConfigFromStroage();
        if (urlData) {
            getIVCData();
        } else {
            getConfigFromParamStore()
                .then(() => {
                    getIVCData();
                })
                .catch((err) => {
                    console.log("Error in fetching config--IVC :: ", err);
                    setLoading(false);
                    setIsSystemDown(true);
                });
        }
    }

    const getIVCData = async () => {
        let [param, txnId] = window.location.search.split('=')
        const { url, body } = getApiData("verifyUser");
        body.request.payload.posvRefNumber = txnId;
        try {
            const response = await axios.post(url, body);
            console.log("Response--IVC :: ", response);
            if (response.data.response.msgInfo.msgCode === "200") {

                if (response?.data?.response?.payload?.submissionRestricted === "Y") {
                    setShowPolicySplittingPage(true);
                    setPolicySplittingMsg(response?.data?.response?.payload?.businessMsg);
                    return;
                }
                if(response?.data?.response?.payload?.ivcTag === "Y") {
                    const openTime = response.data.response.payload.openTime;
                    const closeTime = response.data.response.payload.closeTime;
                    const ivcVideoUrl = response.data.response.payload.ivcVideoUrl;
                    const ivcDowntimeHeading = response.data.response.payload.ivcDowntimeHeading;
                    const ivcDowntimeMessage = response.data.response.payload.ivcDowntimeMessage
                    const windowOpenStatus = response.data.response.payload.windowOpenStatus;
                    if(!ivcVideoUrl) {
                        throw new Error("IVC Video URL is not available");
                    } else if(windowOpenStatus) {
                        setIsWindowOpen(true);
                        setIvcVideoUrl(ivcVideoUrl);
                    } else {
                        setIvcDowntimeHeading(ivcDowntimeHeading);
                        setIvcDowntimeMessage(ivcDowntimeMessage);
                        setIsWindowClosed(true);
                    }
                } else if(response?.data?.response?.payload?.ivcTag?.toLowerCase() === "posv") {
                    router.push(`/vu?id=${txnId}`);
                } else {
                    if(response?.data?.response?.payload?.isLinkValid === false) {
                        setIsLinkInvalid(true);
                        setInvalidLinkMsg(response?.data?.response?.payload?.businessMsg)
                    } else {
                        setIsSystemDown(true);
                    }
                }
            } else {
                setIsSystemDown(true);
            }
        } catch (error) {
            console.log("Error in validating--IVC :: ", error);
            setIsSystemDown(true);
        } finally {
            console.log("In Finally");
            setLoading(false);
        }
    }

    if (loading) return <DotsLoader msg={"Please Wait"} />

    if (isLinkInvalid) {
        return <WindowClosed ivcDowntimeMessage={"Please get in touch with your seller for a valid link"} ivcDowntimeHeading={"Link Expired"} />
    }

    if (showPolicySplittingPage) {
        return <IVCPolicySpliting policySplittingMessage={policySplittingMsg} />;
    }

    if (isSystemDown) {
        return (
            <SystemDown />
        );
    }

    if (isWindowOpen) {
        return (
            <IVCWelcomeScreen ivcVideoUrl={ivcVideoUrl} />
        );
    }

    if (isWindowClosed) {
        return (
            <WindowClosed ivcDowntimeHeading={ivcDowntimeHeading} ivcDowntimeMessage={ivcDowntimeMessage} />
        );
    }

    return null;
};

export default IVCPage;